import React, { useState, useEffect, useContext } from 'react';
import { collection, getDocs, deleteDoc, doc } from 'firebase/firestore';
import { db } from '../../auth/config';
import SideButton from './SideButton';
import Header from './Header';

import {
  Box, Typography, CssBaseline, AppBar, Toolbar, Button,
  List, ListItem, ListItemText, Divider, Backdrop, CircularProgress
} from '@mui/material';

import AuthContext from '../../auth/Auth-context';

const drawerWidth = 270;

const listStyle = {
  p: 0,
  width: '100%',
  maxWidth: 768,
  borderRadius: 2,
  border: '1px solid',
  borderColor: 'divider',
  backgroundColor: 'background.paper',
};

function User_Management() {
  const [open, setOpen] = useState(false);
  const [onloadData, setOnloadData] = useState([]);
  const authCtx = useContext(AuthContext);

  useEffect(() => {
    if (!authCtx.email) return;

    // Optional access check logic:
    // if (authCtx.email !== 'bellaryharsha4u@gmail.com') {
    //   alert('Access Denied');
    //   return;
    // }

    getOnloadList();
  }, []);

  const getOnloadList = async () => {
    const data = await getDocs(collection(db, 'inviteUsers'));
    const dataArray = data.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
    setOnloadData(dataArray);
  };

  const DelUser = async (id, emailId) => {
    const confirmText = `Are you sure you want to delete ${emailId}?`;
    if (!window.confirm(confirmText)) return;

    setOpen(true);
    try {
      await deleteDoc(doc(db, 'inviteUsers', id));
      await getOnloadList();
    } catch (err) {
      console.error('Failed to delete user:', err);
    } finally {
      setOpen(false);
    }
  };

  return (
    <div>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <AppBar
          position="fixed"
          sx={{ width: `calc(100% - ${drawerWidth}px)`, ml: `${drawerWidth}px` }}
        >
          <Toolbar style={{ background: '#fff' }}>
            <Typography variant="h6" noWrap component="div" sx={{ color: '#333', fontWeight: 'bold' }}>
              Analytics Tool
            </Typography>
            <Header />
          </Toolbar>
        </AppBar>

        <SideButton />

        <Box component="main" sx={{ flexGrow: 1, bgcolor: 'background.default', p: 3 }}>
          <Toolbar />
          <div className="container pt-1">
            <Typography variant="h6" gutterBottom><b>Active Users</b></Typography>
            <List sx={listStyle}>
              {onloadData.map((item, index) => (
                <div key={item.id}>
                  <ListItem
                    secondaryAction={
                      <Button color="error" onClick={() => DelUser(item.id, item.EmailId)}>
                        Delete
                      </Button>
                    }
                  >
                    <ListItemText primary={item.EmailId} secondary={`Level: ${item.Level}`} />
                  </ListItem>
                  <Divider component="li" />
                </div>
              ))}
            </List>
          </div>
        </Box>
      </Box>
    </div>
  );
}

export default User_Management;
